import React from "react";
import { Routes, Route, Outlet, Link } from "react-router-dom";
import AddressForm from "components/hahs/AddressForm";
import InfoForm from "components/hahs/InfoForm";
import DateOfBirthForm from "components/hahs/DateOfBirthForm";
import PaymentForm from "components/hahs/PaymentForm";
import { StripeElementsOptionsMode, loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import SuccessPage from "components/hahs/Success";

const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY);
const stripeHahsSubscriptionOptions: StripeElementsOptionsMode = {
  mode: "subscription",
  amount: 10449,
  currency: "usd",
  appearance: {
    theme: "stripe",
    rules: {
      ".Input": {
        border: "2px solid #038fca",
        outline: "none",
        borderRadius: "0.375rem;",
      },
      ".Input:focus": {
        border: "1px solid #C4C4C4",
        outline: "none",
      },
    },
  },
};

export function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="hahs" element={<Layout />}>
            <Route index element={<InfoForm />} />
            <Route path="dob" element={<DateOfBirthForm />} />
            <Route path="address" element={<AddressForm />} />
            <Route path="success" element={<SuccessPage />} />
            <Route
              path="payment"
              element={
                <Elements
                  stripe={stripePromise}
                  options={stripeHahsSubscriptionOptions}
                >
                  <PaymentForm />
                </Elements>
              }
            />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}
function Layout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page </Link>
      </p>
    </div>
  );
}
